import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    container: {
        backgroundColor: 'white',
        borderRadius: '6px',
        position: 'relative',
        height: 'calc(100vh - 128px)',
        padding: '0 50px 23px 50px',
        overflow: 'auto',
        direction: (props) => (props.rtl ? 'rtl' : 'ltr'),
        // textAlign: (props) => (props.rtl ? 'right' : 'left'),
        [theme.breakpoints.down(1025)]: {
            padding: '0',
            height: 'calc(100vh - 179px)'
        }
    },
    mainContainer: {
        width: '100%',
        backgroundColor: '#f2f4fa',
        [theme.breakpoints.down(1025)]: {
            background: '#fff',
            overflow: 'auto',
            width: 'auto'
        }
    },

    row: {
        display: 'flex',
        flexDirection: 'row-reverse',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '35px'
    },
    title: {
        marginLeft: 'auto',
        fontFamily: 'inherit',
        fontSize: '18px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '1.72',
        letterSpacing: 'normal',
        textAlign: 'right',
        color: '#232733'
    },

    overallInfo: {
        display: 'flex',
        alignItems: 'center',
        maxWidth: '250px'
    },
    header: {
        color: '#767676',
        maxWidth: '250px',
        position: 'sticky',
        top: '0',
        zIndex: '2'
    },
    headerListItem: {
        display: 'grid',
        gridTemplateColumns: '3fr 2fr 1fr 2fr 2fr 3fr',
        gridGap: '10px',
        position: 'sticky',
        borderBottom: ' solid 0.8px #dadce0',
        background: '#fff',
        top: '0',
        zIndex: '5',
        '& > div ': {
            padding: '24px 0',
            whiteSpace: 'nowrap',
            width: '100%',
            // maxWidth: '300px',
            // minWidth: '220px',
            textAlign: 'start'
        },
        '& > div:nth-child(1) ': {
            paddingInlineStart: '24px'
        },
        '& > div:nth-child(4) ': {
            paddingInlineStart: '24px'
        },
        // '& > div:nth-child(1)': {
        //     textAlign: 'start'
        // },
        // '& > div:nth-child(3) ': {
        //     minWidth: '120px'
        // },
        // [theme.breakpoints.up(1265)]: {
        //     '& > div ': {
        //         minWidth: '250px'
        //     }
        // },
        [theme.breakpoints.down(1025)]: {
            // gridTemplateColumns: '165px 150px 130px 150px 150px 200px',

            '& > div ': {
                // minWidth: '165px',
                textAlign: 'center'
            }
        }
        //     '& > div:nth-child(3) ': {
        //         minWidth: '130px'
        //     },
        //     '& > div:nth-child(5) ': {
        //         minWidth: '155px'
        //     }
        // }
    },
    fixedBtnContainer: (props) => ({
        position: 'fixed',
        left: props.rtl ? '55px' : 'auto',
        right: props.rtl ? 'auto' : '55px',
        bottom: '50px'
    }),
    reportBtn: {
        borderRadius: '23px',
        '& img': {
            margin: '0 7px'
        }
    },
    allPatientInPatients: {
        borderRadius: '6px',
        marginBottom: '10px',
        marginLeft: '25px'
    },
    NID: {
        width: '115px'
        // marginInlineEnd: '10px'
        // textAlign: 'inherit'
    },
    age: {
        width: '100px',
        '& *': {
            wordSpacing: '.2em'
        }
    },
    phone: {
        // [theme.breakpoints.up(1025)]: {
        //     marginInlineStart: '10px'
        // }
    },
    clinic: {
        // width: '120px'
    },
    overall: {
        width: '255px',
        display: 'flex'
    },
    lastVisitDate: {
        width: '150px'
    },
    lastVisitTime: {
        width: '223px',
        '& > span:first-child': {
            paddingLeft: '15px',
            minWidth: '70px',
            display: 'inline-block'
        }
    },
    loading: (props) => ({
        textAlign: 'center',
        direction: 'ltr',
        color: 'gray',
        marginTop: '13px',
        visibility: props.length ? 'visible' : 'hidden'
    }),
    listContainer: {
        listStyle: 'none',
        margin: '0',
        minWidth: '970px',
        [theme.breakpoints.down(1025)]: {
            padding: '0 24px',
            minWidth: '800px'
        }
    },
    iconContainer: {
        width: '17.7px',
        height: '17.7px'
    },
    loadingContainer: {
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    progress: {
        color: '#063f5e'
    },
    notExistWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        '& > span': {
            marginTop: '15px',
            fontFamily: 'inherit',
            fontWeight: 'normal'
        }
    }
}));
export { useStyles };
